import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
const Recaptcha = require('react-recaptcha');

import DatePicker from "../../../general/DatePicker";
import {postRemuneration, closePopup,getRemunerationYears,clearRemuneration  } from '../../Modal/action';
import {formDataGenerator, getDropdownData  } from "../../../../../utils/common";
import Input from "../../Input/index";
import Dropdown from '../../dropdown';
import './style.scss';

@connect((state)=>({
    remunerationYears:state.modal.remunerationYears,
    remunerationLogin:state.modal.remunerationLogin,
}),(dispatch)=>({
    ...bindActionCreators({postRemuneration,closePopup,getRemunerationYears, clearRemuneration },dispatch),
}))
export default class RemunerationLogin extends Component {

    constructor(props){
        super(props);
        this.state={
            folioNumber:'',
            informationType: '',
            informationValue: '',
            financialYear:'',
            captchaToken: '',
            errors:{},
            folioerror: false,
        };
        this.errors={};
        // create a variable to store the component instance
        this.recaptchaInstance;
    }

    loadScript() {
        this.script = document.createElement('script');
        this.script.src = 'https://www.google.com/recaptcha/api.js';
        this.script.defer = true; // Set defer attribute to execute after document parsing
    
        // Append the script to the document body
        document.body.appendChild(this.script);
    }

    componentDidMount(){
        let {getRemunerationYears}=this.props;
        getRemunerationYears();
        this.loadScript();
    }

    removeClass = (element,className)=>{
        element ? element.classList.contains(className) && element.classList.remove(className)
            : console.log('Element not Found! Cannot remove "error" class');
    }
    validateChange=(name,value)=>{
        let element =document.getElementsByName(name)&&document.getElementsByName(name)[0];
        if(value) {
            switch (name) {
                // case 'folioNumber':
                //     /^[a-zA-Z\s]*$/.test(value)?  delete this.errors[name] :
                //         this.errors.firstName = 'only alphabets allowed';
                //     break;
                default:
                    this.errors[name] ? delete this.errors[name] : false
            }
            this.errors[name] ? element.classList.add('error') : this.removeClass(element,'error');
        }
        this.setState({
            errors: this.errors
        })
    };
    
    onChange=(name,value)=>{
        // this.setState(state);
        this.setState({[name]:value},()=>{
            this.validateChange(name,value)
        });
       
    };
    onDropdownChange = (name, value)=>{
        this.setState({
            [name]:value,
        });
        if(name=="informationType"){
            this.setState({informationValue: ''})
        }
    };
    getFormData=(data)=>{
        return formDataGenerator(data);
    };

    onSubmit=async()=>{
        let clientIp =document.getElementsByClassName('user-ip') && document.getElementsByClassName('user-ip')[0] && document.getElementsByClassName('user-ip')[0].innerText
        let {postRemuneration } = this.props,
            data={
                folioNumber:this.state.folioNumber,
                verificationDoc:this.state.informationType.value,
                verificationValue:this.state.informationType.value !='DATE_OF_BIRTH'?this.state.informationValue:this.state.informationValue.format('DD-MM-YYYY') ,
                fiscalYear:this.state.financialYear.value,
                ip:clientIp,
                applicationType:'WEB',
                captchaToken: this.state.captchaToken
            };
        await postRemuneration(this.getFormData(data));
        const {remunerationLogin,closePopup}=this.props;
        (remunerationLogin && remunerationLogin.data.status) && closePopup();
        (remunerationLogin && !remunerationLogin.data.status) && this.resetRecaptcha();
    };
    componentWillUnmount(){
        if(this.props.remunerationLogin  && this.props.remunerationLogin.data && !this.props.remunerationLogin.data.status){
            this.props.clearRemuneration()
        }

    }
    handleReset=(event)=>{
        event.preventDefault();
        this.setState({
            folioNumber:'',
            informationType:'',
            informationValue:'',
            financialYear:'',
            captchaToken: '',
            error:'',
            folioerror: true,
        })

    };
    // callback = () =>{
    //     console.log('Done!!!!');
    // };

    // specifying verify callback function
    verifyCallback = (response) =>{
        this.setState({
           captchaToken: response
        });
        // console.log(response);
    };
    getLabel=(infoType)=>{
        let label;
        if(infoType) {
            switch (infoType.value) {
                case 'PAN':
                    label = 'Enter PAN/PEKRN';
                    break;
                case 'ACCOUNT_NO':
                    label = 'Enter Bank Account Number';
                    break;
                case 'MOBILE':
                    label = 'Enter Mobile Number';
                    break;
                case 'EMAIL':
                    label = 'Enter Email ID';
                    break;
                case 'NAME':
                    label = 'Enter Name';
                    break;
                default:
                    break;
            }

        }
        return label;

    };


    // create a reset function
    resetRecaptcha = () => {
        this.recaptchaInstance.reset();
    };

    render() {
        let { closePopup, modalData, remunerationYears, remunerationLogin} = this.props,
            { captchaToken, financialYear ,informationValue,informationType,folioNumber, folioerror} = this.state,
            disabled = captchaToken &&  financialYear && informationValue && informationType && folioNumber? false : true;
        let informationList={'PAN':'PAN','ACCOUNT_NO':'Bank a/c','DATE_OF_BIRTH':'Date of Birth','MOBILE':'Mobile Number', 'EMAIL':'Email ID', 'NAME':'Name'},informationValueList=[],financialYearList=[];
        return (
        <div className="modal-body clearfix">
            {(remunerationLogin==undefined || (remunerationLogin.data && !remunerationLogin.data.status)
                || Object.keys(remunerationLogin).length==0)&& <ul className="remuneration-form">
                    <li className="col-12 folioNumber">
                        <Input name='folioNumber' value={this.state.folioNumber}
                               required={true}
                               isNumeric={true}
                               labelName="Folio Number"
                               onChange={this.onChange} blurChange={this.validateChange} />
                       <div className="rules">
                           Please enter folio number without the check digit. e.g. If folio number is 123456/78,
                           please enter 123456 only.</div>
                    </li>
                    <li className="financialYear col-12 form-data">
                        <Dropdown dropdownOptions={getDropdownData(remunerationYears)} dropdownLabel='Financial Year' sort={true}
                          getValue={true} defaultSelected={financialYear}
                          name='financialYear' onSelect={this.onDropdownChange.bind(this,'financialYear')}
                        />
                    </li>
                    <li className="col-12">
                        <div className={!informationType?"informationType col-12 col-sm-12 form-data":"informationType col-6 col-sm-12 form-data"}>
                            <Dropdown dropdownOptions={getDropdownData(informationList)} dropdownLabel='Input'  getValue={true}
                                      defaultSelected={informationType}  isAutocapital={false}
                                      name='informationType' onSelect={this.onDropdownChange.bind(this,'informationType')}
                                     />
                        </div>
                        {informationType && informationType.value !='DATE_OF_BIRTH' &&
                        <div className="informationValue col-6 col-sm-12 form-data">
                            <Input name='informationValue' value={informationValue}
                               labelName={this.getLabel(informationType)}  required={true}
                               onChange={this.onChange} blurChange={this.validateChange} />
                        </div>}
                        {informationType && informationType.value=="MOBILE" && <div className="rules">
                            Please enter mobile number without the prefix of country code e.g.
                            If mobile number is +915454545454 please enter 5454545454 only.</div>
                        }
                        {informationType && informationType.value =='DATE_OF_BIRTH' &&
                        <div className="informationValue col-6 col-sm-12 form-data">
                            <DatePicker name='informationValue' selected={informationValue} placeholderText="DD/MM/YYYY"
                                        showYearDropdown showMonthDropdown updateParent={this.onChange}
                                        maxDate={ moment().subtract(18, "year")} />
                        </div>}

                    </li>

                    <li className="col-12 form-data captcha">
                        <Recaptcha
                            ref={e => this.recaptchaInstance = e}
                            sitekey="6LcKVAsUAAAAAFIptnZfbQ35CNbQdYI4YOW40tuX"
                            render="explicit"
                            verifyCallback={this.verifyCallback}
                            onloadCallback={this.callback}
                        />
                    </li>
                    {remunerationLogin && remunerationLogin.statusMsg &&  folioerror == false ?
                    <div className="error-style">{remunerationLogin.statusMsg}</div> : ''}
                    {remunerationLogin && remunerationLogin.data && remunerationLogin.data.message && folioerror == false ?
                    <div className="error-style">{remunerationLogin.data.message}</div>: ''}
                    <li className="action-button">
                        <button className='btn-primary' disabled={disabled} onClick={this.onSubmit}>SUBMIT</button>
                        <div>or</div>
                        <div><a onClick={this.handleReset} className='blue-link'>RESET</a></div>
                    </li>
                </ul>}
            </div>
        );

    }
}

